<template>
  <v-navigation-drawer
    :model-value="newActionComponentProps"
    class="rm-right-drawer"
    @update:model-value="handleModelValueChange"
    temporary
    :order="-1"
    location="right"
    width="545"
  >
    <NewActions
      v-if="newActionComponent"
      :currentRepairFile="currentRepairFile"
      :rentalFileId="rentalFileId"
      @closeNewAction="handleCloseNewAction()"
      @openDeliveryClient="(action) => handleOpenDeliveryClient(action)"
      @openEstimateRepairer="handleOpenEstimateRepairer()"
      @openEstimateRepairerDetail="handleOpenEstimateRepairerDetail()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @showUpdateRepairFileStatusModal="handleShowUpdateRepairFileStatusModal()"
      @openRentalWarningModal="handleOpenRentalWarningModal()"
    />
    <DeliveryClient
      v-if="deliveryClientComponent"
      :currentRepairFile="currentRepairFile"
      :actionType="deliveryActionType"
      @cancelDeliveryClient="handleCancelDeliveryClient()"
      @closeDeliveryClient="handleCloseDeliveryClient()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
    />
    <EstimateRepairer
      v-if="estimateRepairerComponent"
      :currentRepairFile="currentRepairFile"
      @cancelEstimateRepairer="handleCancelEstimateRepairer()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @closeNewAction="handleCloseNewAction()"
    />
  </v-navigation-drawer>
</template>

<script>
import DeliveryClient from '@/components/repair-files/right-drawer/DeliveryClient.vue'
import NewActions from '@/components/repair-files/right-drawer/NewActions.vue'
import EstimateRepairer from '@/components/repair-files/right-drawer/estimate-repairer/EstimateRepairer.vue'

export default {
  components: { EstimateRepairer, NewActions, DeliveryClient },
  props: {
    newActionComponentProps: Boolean,
    currentRepairFile: Object,
    rentalFileId: Object,
    openDeliveryClientDrawer: Boolean,
    refreshCurrentRepairFile: Function
  },
  data() {
    return {
      loading: false,
      error: null,
      newActionComponent: false,
      deliveryClientComponent: false,
      estimateRepairerComponent: false,
      deliveryActionType: undefined,
      bodyOverflowBeforeOpen: null,
      htmlOverflowBeforeOpen: null
    }
  },
  unmounted() {
    this.setBodyScrollLocked(false)
  },
  watch: {
    newActionComponentProps() {
      if (this.newActionComponentProps === true) {
        this.setBodyScrollLocked(true)
        if (this.openDeliveryClientDrawer) {
          this.handleOpenDeliveryClient('close')
          return
        }
        this.newActionComponent = true
        this.deliveryClientComponent = false
        this.estimateRepairerComponent = false
        this.$emit('reset-delivery-client-state', false)
      } else {
        this.setBodyScrollLocked(false)
        this.newActionComponent = false
        this.$emit('reset-delivery-client-state', false)
      }
    }
  },
  methods: {
    setBodyScrollLocked(shouldLock) {
      if (shouldLock) {
        if (this.bodyOverflowBeforeOpen === null) {
          this.bodyOverflowBeforeOpen = document.body.style.overflow
        }
        if (this.htmlOverflowBeforeOpen === null) {
          this.htmlOverflowBeforeOpen = document.documentElement.style.overflow
        }
        document.documentElement.style.overflow = 'hidden'
        document.body.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = this.htmlOverflowBeforeOpen ?? ''
        document.body.style.overflow = this.bodyOverflowBeforeOpen ?? ''
        this.bodyOverflowBeforeOpen = null
        this.htmlOverflowBeforeOpen = null
      }
    },
    handleModelValueChange(value) {
      if (value === false) {
        this.$emit('close')
      }
    },
    handleCloseNewAction() {
      this.$emit('close')
    },
    handleOpenDeliveryClient(actionType) {
      this.newActionComponent = false
      this.deliveryClientComponent = true
      this.deliveryActionType = actionType
    },
    handleCancelDeliveryClient() {
      this.newActionComponent = true
      this.deliveryClientComponent = false
      this.deliveryActionType = undefined
    },
    handleCloseDeliveryClient() {
      this.$emit('close')
      this.$emit('updateCurrentRepairFile')
      this.$emit('showGuaranteeExtensionBoomerangModal')
    },
    handleUpdateRepairFile() {
      this.$emit('updateCurrentRepairFile')
    },
    async handleOpenEstimateRepairer() {
      if (this.refreshCurrentRepairFile) {
        await this.refreshCurrentRepairFile()
      }
      this.newActionComponent = false
      this.estimateRepairerComponent = true
    },
    handleCancelEstimateRepairer() {
      this.newActionComponent = true
      this.estimateRepairerComponent = false
    },
    async handleOpenEstimateRepairerDetail() {
      if (this.refreshCurrentRepairFile) {
        await this.refreshCurrentRepairFile()
      }
      this.newActionComponent = false
      this.estimateRepairerComponent = true
    },
    handleShowUpdateRepairFileStatusModal() {
      this.$emit('showUpdateRepairFileStatusModal')
    },
    handleOpenRentalWarningModal() {
      this.$emit('openRentalWarningModal')
    }
  }
}
</script>
